export default __webpack_public_path__ + "static/media/WAS0333.34I-41697_-25000_0.7044e08b.jpg";